import React from "react";

const FOTOS = [
  "https://lh3.googleusercontent.com/p/AF1QipPph1BLU5g6RZR2OEHRe1qPGCn5RHJnfWIvlns1=w408-h408-k-no",
  "https://lh3.googleusercontent.com/p/AF1QipO-v8jaTKhSoKpNPCZsvAyDwKE9T2m9KhQh9B1g=s680-w680-h510-rw",
  "https://lh3.googleusercontent.com/p/AF1QipPDAyf2uMWOKFeKcof3ZMgf3LGBDl9xQFo14E3n=s680-w680-h510-rw",
  "https://lh3.googleusercontent.com/p/AF1QipMkmVTAUyiCwh8IPLAYU5k7QA3o74a_3KINGdLi=s680-w680-h510-rw",
  "https://lh3.googleusercontent.com/p/AF1QipNr7IXYJSfEvJD7vuDXY5JPCR1J9iVaBPwT0duX=s680-w680-h510-rw",
  "https://lh3.googleusercontent.com/p/AF1QipPhBhKBTRntpKfWONAdCEc59d1HBdRZqYl2lO43=s680-w680-h510-rw",
  "https://lh3.googleusercontent.com/p/AF1QipO6gattZPhzVEq1uzjBKhEV6CgKwbK5Cu_tUDI-=s680-w680-h510-rw",
  "https://lh3.googleusercontent.com/p/AF1QipOlbXFKOq2io-NPuHUh24Gh21ZJlr_7Jxi-dzA-=s680-w680-h510-rw",
  "https://lh3.googleusercontent.com/p/AF1QipOlJxHl1XWtvzwVjOGAyhbpJvK_6GO52tCezkDu=s680-w680-h510-rw"
];

const SobreNosotrosPage = () => (
  <div className="container mx-auto py-12 px-4">
    <h1 className="text-4xl font-extrabold mb-4 text-center text-blue-900">Sobre Atlantis Fish</h1>
    <p className="text-lg text-gray-700 mb-10 max-w-3xl mx-auto text-center">
      Somos una empresa familiar dedicada a la acuariofilia desde hace más de 10 años. Creemos que cada acuario es un mundo único y cada cliente es parte de nuestra familia. <br /><br />
      Visítanos, comparte tu pasión y descubre todo lo que tenemos para ti.
    </p>
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
      {FOTOS.map((foto, i) => (
        <img
          key={i}
          src={foto}
          alt={`Negocio Atlantis Fish ${i + 1}`}
          className="rounded-xl shadow-lg w-full h-64 object-cover"
        />
      ))}
    </div>
    {/* Aquí puedes poner historia, valores, misión, equipo, etc */}
  </div>
);

export default SobreNosotrosPage;
